import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'

window.mode = (window.localStorage && localStorage.getItem('test')) ? 'test' : 'live'
window.stripeUrl = 'https://dashboard.stripe.com/' + (window.mode === 'test' ? 'test/' : '')

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
